import { CREATE_DISCIPLINARY_RECORD, CREATING_DISCIPLINARY_RECORD, DISCIPLINARY_RECORDS_ERROR, GETTING_DISCIPLINARY_RECORDS, GET_DISCIPLINARY_RECORDS, UPDATE_DISCIPLINARY_RECORD, UPDATING_DISCIPLINARY_RECORD} from "../types"

const initialState = {
    disciplinaryRecords: [],
    loadingDisciplinaryRecords: false,
    disciplinaryRecordsError: null,
    creatingDisciplinaryRecord: false,
    createdDisciplinaryRecord: null,
    updatingDisciplinaryRecord: false,
    updatedDisciplinaryRecord: null,
    signingDisciplinaryRecord: false,
    signedDisciplinaryRecord: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_DISCIPLINARY_RECORDS:
        return {
            ...state,
            loadingDisciplinaryRecords: action.payload,
            // fetchingMembers:false
        }
        case GET_DISCIPLINARY_RECORDS:
        return{
            ...state,
            loadingDisciplinaryRecords: false,
            disciplinaryRecordsError: false,
            disciplinaryRecords: action.payload,
        }
        case CREATING_DISCIPLINARY_RECORD:
        return {
            ...state,
            creatingDisciplinaryRecord: action.payload,
            // fetchingMembers:false
        }
        case CREATE_DISCIPLINARY_RECORD:
        return{
            ...state,
            creatingDisciplinaryRecord:false,
            disciplinaryRecordsError: null,
            createdDisciplinaryRecord: action.payload,
        }
        case UPDATING_DISCIPLINARY_RECORD:
        return {
            ...state,
            updatingDisciplinaryRecord: action.payload,
            // fetchingMembers:false
        }
        case UPDATE_DISCIPLINARY_RECORD:
        return{
            ...state,
            updatingDisciplinaryRecord:false,
            disciplinaryRecordsError: null,
            updatedDisciplinaryRecord: action.payload,
        }
        // case SIGNING_DISCIPLINARY_RECORD:
        // return {
        //     ...state,
        //     signingDisciplinaryRecord: action.payload,
        //     // fetchingMembers:false
        // }
        // case SIGN_DISCIPLINARY_RECORD:
        // return{
        //     ...state,
        //     signingDisciplinaryRecord:false,
        //     disciplinaryRecordsError: null,
        //     signedDisciplinaryRecord: action.payload,
        // }
        case DISCIPLINARY_RECORDS_ERROR:
        return{
            ...state,
            loadingDisciplinaryRecords:false,
            creatingDisciplinaryRecord: false,
            updatingDisciplinaryRecord: false,
            disciplinaryRecordsError: action.payload 
        }
        default: return state
    }

}